var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"button-whatsapp",attrs:{"elevation":"1","icon":""},on:{"click":_vm.redirectWhatsapp}},[_c('v-icon',{attrs:{"color":"#FFFFFF","size":"28px"}},[_vm._v(" mdi-whatsapp ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }